import {validateSchema} from 'app/common/validations';
import reduceReducers from 'reduce-reducers';
import update from 'immutability-helper';
import {company} from 'app/client/api';
import {showAppBusy, handleAppError} from './app';
import I18n from 'app/common/i18n';
import _ from 'lodash';

import {history} from 'store';
import * as routePath from 'app/utils/routePath';

const initialState = {
  name: '',
  logins: [{
    name: '',
    email: ''
  }],
  assessmentsPurchased: '',
  companiesCount: {
    totalCount: 0,
    timePeriodBasedCount: 0
  },
  errors: {}
};

const SCHEMA_ID = 'dk-admin/createCompany';

const UPDATE_COMPANY_NAME = "company/UPDATE_COMPANY_NAME";
const UPDATE_COMPANY_LOGIN_NAME = "company/UPDATE_COMPANY_LOGIN_NAME";
const UPDATE_COMPANY_LOGIN_EMAIL = "company/UPDATE_COMPANY_LOGIN_EMAIL";
const UPDATE_COMPANY_ASSESSMENT_PURCHASED = 'company/UPDATE_COMPANY_ASSESSMENT_PURCHASED';
const RESET_COMPANY = "company/RESET_COMPANY";
const COMPANY_VALIDATION_ERRORS = "company/COMPANY_VALIDATION_ERRORS";
const RECEIVE_TOTAL_COMPANIES_COUNT = 'company/RECEIVE_TOTAL_COMPANIES_COUNT';
const RECEIVE_TIME_PERIOD_BASED_COMPANIES_COUNT = 'company/RECEIVE_TIME_PERIOD_BASED_COMPANIES_COUNT';

export function receiveCompaniesCount(count, timePeriod) {
  if(timePeriod) {
    return {type: RECEIVE_TIME_PERIOD_BASED_COMPANIES_COUNT, payload: count}
  }
  return {type: RECEIVE_TOTAL_COMPANIES_COUNT, payload: count}
}

export function updateCompanyName(payload) {
  return {type: UPDATE_COMPANY_NAME, payload}
}

export function updateCompanyLoginName(payload) {
  return {type: UPDATE_COMPANY_LOGIN_NAME, payload}
}

export function updateCompanyLoginEmail(payload) {
  return {type: UPDATE_COMPANY_LOGIN_EMAIL, payload}
}

export function resetCompany() {
  return {type: RESET_COMPANY, payload: initialState}
}

export function companyValidationErrors(payload) {
  return {type: COMPANY_VALIDATION_ERRORS, payload}
}

export function updateCompanyAssessmentPurchased(payload) {
  return {type: UPDATE_COMPANY_ASSESSMENT_PURCHASED, payload}
}

export function handleCreateCompany() {
  return async (dispatch, getState) => {
    let companyState = getState().company;
    let companyInfo = {
      name: companyState.name,
      logins: companyState.logins,
      login: companyState.logins[0],
      assessmentsPurchased: companyState.assessmentsPurchased
    }
    let validationErrors = validateSchema(companyInfo, SCHEMA_ID);
    companyInfo = _.omit(companyInfo, ['logins']);
    if (_.isEmpty(validationErrors)) {
      dispatch(showAppBusy(true));
      try {
        await company(companyInfo);
        dispatch(showAppBusy(false));
        history.push(routePath.companyOnboardSuccessRoute);
      } catch (exception) {
        dispatch(showAppBusy(false));
        let meta = exception && exception.response && exception.response.data && exception.response.data.meta;
        if (!_.isEmpty(meta)) {
          dispatch(companyValidationErrors(meta));
        } else {
          dispatch(handleAppError(exception, I18n.t('errors.unexpected')));
        }
      }
    } else {
      dispatch(companyValidationErrors(validationErrors));
    }
  }
}


function validator(state = initialState, action) {
  let {type} = action;
  switch (type) {
    case UPDATE_COMPANY_NAME:
    case UPDATE_COMPANY_LOGIN_NAME:
    case UPDATE_COMPANY_LOGIN_EMAIL:
    case UPDATE_COMPANY_ASSESSMENT_PURCHASED:
      let validationErrors = validateSchema(state, SCHEMA_ID);
      return update(state, {errors: {$set: validationErrors}});
    default:
      return state;
  }
}

function reducer(state = initialState, action) {
  let {payload, type} = action;
  switch (type) {
    case UPDATE_COMPANY_NAME:
      return update(state, {name: {$set: payload}});

    case UPDATE_COMPANY_LOGIN_NAME:
      return update(state, {logins: {[0]: {name: {$set: payload}}}});

    case UPDATE_COMPANY_LOGIN_EMAIL:
      return update(state, {logins: {[0]: {email: {$set: payload}}}});

    case UPDATE_COMPANY_ASSESSMENT_PURCHASED:
      return update(state, {assessmentsPurchased: {$set: payload}});

    case COMPANY_VALIDATION_ERRORS:
      return update(state, {errors: {$set: payload}});

    case RECEIVE_TOTAL_COMPANIES_COUNT:
      return update(state, {companiesCount: {totalCount: {$set: payload} } });

    case RECEIVE_TIME_PERIOD_BASED_COMPANIES_COUNT:
      return update(state, {companiesCount: {timePeriodBasedCount: {$set: payload} } });

    case RESET_COMPANY:
      return update(state, {
          name: {$set: payload.name}, 
          companyId: {$set: payload.companyId}, 
          location: {$set: payload.location},
          logins: {$set: payload.logins},
          assessmentsPurchased: {$set: payload.assessmentsPurchased},
          errors: {$set: payload.errors}
        });

    default:
      return state;
  }
}

export default reduceReducers(
  reducer,
  validator
)


// WEBPACK FOOTER //
// ./src/reducers/company.js